<template>
    <div class="filter-panel d-flex justify-content-between">
        <div class="filter-control" style="width: 70%" @click="onOpenCloseFilter">
            <div class="d-flex justify-content-between">
                <div>
                    <a href="javascript:void(0)" class="text-secondary"><b>Filtra risultati</b><span> | {{counter}}</span></a>
                </div>
                <div>
                    <button class="btn btn-sm btn-secondary mr-2" :disabled="isDisabledReset" @click="onResetFilter">reset</button>
                </div>
            </div>
        </div>
        <div class="px-2" style="width: 30%">
            <CustomOrderSelect :list="orders" class="lg gray" :value="order" @change="onChangeOrder"/>
        </div>
        <div class="map">
            <div>
                <a href="javascript:void(0)" @click="onOpenMap">mappa</a>
            </div>
        </div>
        <div @mouseleave="openFilter = false">
            <DropdownFilterService v-show="openFilter" :list="list" :value="getFilter()" :is-trasferimento="isTrasferimento"/>
        </div>
        <ModalServicesMap :is-trasferimento="isTrasferimento" ref="modalServicesMap"/>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import DefaultModal from '../../../../back/components/pages/layout/DefaultModal'
import DropdownFilterService from '../common/dropdown/DropdownFilterService'
import ModalServicesMap from './modals/ModalServicesMap'
import CustomOrderSelect from './CustomOrderSelect'

export default {
  name: 'FilterServicePanel',
  components: {CustomOrderSelect, ModalServicesMap, DropdownFilterService, DefaultModal},
  props: {
    counter: Number,
    list: Array,
    isTrasferimento: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      openFilter: false,
      orders: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ],
      openOrder: false
    }
  },
  computed: {
    order () {
      return {name: 'prezzo', dir: this.getOrder()['prezzo']}
    },
    isDisabledReset () {
      return Object.values(this.getFilter()).every(x => x == null)
    }
  },
  methods: {
    ...mapGetters(['getListaServizi', 'getServiziFilter', 'getServiziOrder', 'getListaTrasferimenti', 'getTrasferimentiFilter', 'getTrasferimentiOrder']),
    ...mapActions(['modifyServiziFilter', 'resetServiziFilter', 'modifyServiziOrder', 'modifyTrasferimentoFilter', 'resetTrasferimentoFilter', 'modifyTrasferimentoOrder']),
    getOrder: function () {
      return this.isTrasferimento ? this.getServiziOrder() : this.getTrasferimentiOrder()
    },
    getFilter: function () {
      return this.isTrasferimento ? this.getTrasferimentiFilter() : this.getServiziFilter()
    },
    resetFilter: function () {
      if (this.isTrasferimento) {
        this.resetTrasferimentoFilter()
      } else {
        this.resetServiziFilter()
      }
    },
    onOpenCloseFilter: function () {
      this.filter = this.getFilter()
      this.openFilter = !this.openFilter
    },
    onOpenOrder: function () {
      this.openOrder = !this.openOrder
      this.openFilter = false
    },
    onOpenMap: function () {
      this.$refs.modalServicesMap.open()
    },
    onChangeFilter: function (filter) {
      this.filter = filter
      if (this.isTrasferimento) {
        this.modifyTrasferimentoFilter(this.filter)
      } else {
        this.modifyServiziFilter(this.filter)
      }
    },
    onResetFilter: function (event) {
      event.stopPropagation()
      this.resetFilter()
      this.filter = this.getFilter()
      this.openFilter = false
    },
    onChangeOrder: function (order) {
      if (this.isTrasferimento) {
        this.modifyTrasferimentoOrder({prezzo: order.dir})
      } else {
        this.modifyServiziOrder({prezzo: order.dir})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/FilterServicePanel.vue